import {useContext} from 'react';
import {AttributeContext} from './AttributeContext';

import type {ConnectHtmlAttributeType} from '../../connect/ConnectJSInterface/HtmlAttributes';

export const useAttributes = () => useContext(AttributeContext);

/**
 * Typically for a boolean HTML attribute, its presence is enough to indicate `true`,
 * regardless of its value. However, we make one exception: if the developer
 * passes the literal string "false", we interpret this as `false` since this
 * is clearly their intention.
 */
export const useBooleanAttribute = (
  attributeType: ConnectHtmlAttributeType,
) => {
  const attributes = useAttributes();

  return Boolean(
    attributes &&
      attributeType in attributes &&
      attributes[attributeType]?.toString().toLowerCase() !== 'false',
  );
};
